import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

import FeedbackLanding from "@/pages/FeedbackLanding";
import Legal from "@/pages/Legal";
import Login from "@/pages/admin/Login";
import ForgotPassword from "@/pages/admin/ForgotPassword";
import ResetPassword from "@/pages/admin/ResetPassword";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import Inbox from "@/pages/admin/Inbox";
import QRCodes from "@/pages/admin/QRCodes";
import PagesJaunes from "@/pages/admin/PagesJaunes";
import Messages from "@/pages/admin/Messages";
import Settings from "@/pages/admin/Settings";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<FeedbackLanding />} />
            <Route path="/mentions-legales" element={<Legal tab="legal" />} />
            <Route path="/confidentialite" element={<Legal tab="privacy" />} />

            <Route path="/admin/login" element={<Login />} />
            <Route path="/admin/forgot-password" element={<ForgotPassword />} />
            <Route path="/admin/reset-password" element={<ResetPassword />} />

            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="retours" element={<Inbox />} />
              <Route path="qr-codes" element={<QRCodes />} />
              <Route path="pagesjaunes" element={<PagesJaunes />} />
              <Route path="messages" element={<Messages />} />
              <Route path="parametres" element={<Settings />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster />
      </AuthProvider>
    </div>
  );
}

export default App;
